/**
 * A unified function that handles authentication-based redirection logic.
 *
 * @param type - The type of authentication check to perform:
 *   - 'authenticated': Redirects to login if not authenticated, returns null if authenticated
 *   - 'unauthenticated': Redirects to dashboard if authenticated, returns null if not authenticated
 *   - 'redirect': Always redirects to either dashboard (if authenticated) or login (if not)
 *
 * @returns Returns `null` if no redirection is needed, otherwise performs a redirect.
 */
import { useAuthStore } from '@/store/auth.store.ts';
import { redirect } from 'react-router';
import { getLoggedInUserDashboardRoute, ROUTES } from '@/constants/route.constant.ts';

type AuthCheckType = 'authenticated' | 'unauthenticated' | 'redirect';
export const checkAuthAndRedirect = (type: AuthCheckType) => {
  const { authToken } = useAuthStore.getState();

  switch (type) {
    case 'authenticated':
      return authToken ? null : redirect(ROUTES.AUTH.LOGIN);

    case 'unauthenticated':
      return authToken ? redirect(getLoggedInUserDashboardRoute()) : null;

    case 'redirect':
      return authToken
        ? redirect(getLoggedInUserDashboardRoute())
        : redirect(ROUTES.AUTH.LOGIN);
  }
};